<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lxth">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">连续退火炉</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;"
        >铜管感应连续退火装置是专门用于紫铜管的感应连续退火装置。它利用中频电源经感应耦合将电能传给连续输送的铜管，对铜管进行在线退火，以改变金属晶体结构，改善铜管的加工性能，提高成材率和产品质量。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <div align="center">
        <table
          style="width:375.0pt;"
          class="ke-zeroborder"
          border="0"
          cellpadding="0"
          cellspacing="0"
          width="500"
        >
          <tbody>
            <tr>
              <td style="background:#F4F4F4;">
                <p style="text-align:center;" align="center">
                  <b>
                    <span
                      style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;"
                    >主要性能参数</span>
                  </b>
                  <span style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"></span>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="top">
                <div align="center">
                  <table
                    style="width:375.0pt;background:black;"
                    class="ke-zeroborder"
                    border="0"
                    cellpadding="0"
                    cellspacing="1"
                    width="500"
                  >
                    <tbody>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >1</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、退火材质</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >磷无氧铜</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >TU1</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、紫铜</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >T1-T4</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、铜管规格</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >最小</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ7×0.3mm</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;</span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >最大</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ13×0.5mm</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >可根据用户要求，按铜管规格提供一套或多套感应加热器</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >3</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、退火温度</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >额定</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >700</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >℃</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >4</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、额定速度</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >300 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >对</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ9.52×0.37</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >铜管，额定速度为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，速度范围为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >30</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >∽</span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">
                              300
                              m
                            </span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >对</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ12.7×0.5</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >铜管，额定速度为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，速度范围为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >30</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >∽</span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">
                              300
                              m
                            </span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >调速精度</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >
                              &nbsp;
                              &nbsp;
                            </span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >优于</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0.1%</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >5</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、总装机容量</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >880 kW</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >（</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >300 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >）</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >
                              <br>980 kW
                            </span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >（</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >）</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >其中：感应加热器功率</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2×350 kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >传动电机功率</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >70kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >控制系统功率</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >10kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >冷却水系统</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >装机容量</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >—100kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >6</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、中频电源</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >输出功率</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2×350 kW</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2×400 kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >输出电压</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >750V</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >输入电压</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >380V</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >工作频率</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >8000Hz</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >冷却水</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >水量</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >24t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >（含电热电容器冷却），水压</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.2-0.4MPa</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >7</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、感应加热器</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >功率因数</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.9</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >电热效率</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.32—0.4</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >洁净水冷却</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >水量</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >56t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，水压</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.3-0.4MPa</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >8</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、冷却水系统</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >采用洁净水闭路循环冷却系统，总循环水量为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >98t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、水压</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.3-0.4Mpa</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >。其中：感应加热器冷却系统为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >56t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >；中频电源冷却系统为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >24t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >（含电热电容器）；淬火水系统为</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >18t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >。（冷却水系统初步选定采用无锡方舟水冷设备厂制造的感应炉专用水冷设备，具体配置由用户负责。）</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style="text-align:center;" align="center">
                  <span style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lxth: require("../../../assets/img/common/lxth.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/lxth.vue